<button pButton label="UTENTE" icon="pi pi-plus" (click)="showDialogForm(true)"></button>

<p-dialog *ngIf="visible" header="Gestione Utenti" [(visible)]="visible" [style]="{width: '65vw'}" [modal]="true"
  [draggable]="false">
  <app-gestione-utenti-form [idCup]="idCup"></app-gestione-utenti-form>
</p-dialog>